module.exports = __webpack_public_path__ + "img/826862556.e4e51734.jpg";